<template>
  <div class="main-container">
    <PageTitle />
    <Chart
      :balances="balances"
      :account-buttons="buttons"
      :is-customer-blocked="isCustomerBlocked"
    />
    <MarketToday />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Chart } from './components/Chart';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  ButtonBoxDecide,
  ButtonPrimary,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { Categories } from '@/types/models/Analytics';
import {
  IDashButtons,
  IDashStatus,
  IHeroBalances
} from '@/modules/trade/services/account';
import { RequestStatus } from '@/modules/trade/store/trade';
import { filtersPortfolioApiIdDependentButtons } from '@/modules/trade/views/TradeView/helpers';

import { Feature } from '@/modules/common/components/Feature';
import { MarketToday } from './components/MarketToday';
import { PageTitle } from './components/PageTitle';

const tradePositionsModule = namespace('tradeModule');
const CustomerModule = namespace('CustomerModule');

@Component({
  components: {
    ButtonBoxDecide,
    Chart,
    Feature,
    MarketToday,
    ButtonPrimary,
    SkeletonLoader,
    PageTitle
  }
})
export default class TradeMain extends Vue {
  @CustomerModule.Getter('isRegulatoryStatusBlocked')
  readonly isCustomerBlocked!: boolean;

  @Prop({ type: Object, default: null })
  readonly dashStatus!: IDashStatus | null;

  @Prop({ type: Array, required: false })
  readonly accountButtons?: IDashButtons[];

  @Prop({ type: Object, required: false })
  readonly balances?: IHeroBalances;

  @tradePositionsModule.State('balancesBrokerRequestStatus')
  readonly balancesBrokerRequestStatus!: RequestStatus;

  readonly RequestStatus = RequestStatus;
  readonly Categories = Categories;
  readonly NebraskaColors = NebraskaColors;

  get buttons() {
    const accountButtons = this.accountButtons || [];

    // Se o serviço de buscar o saldo teve erro, a gente não tem o portfolioApiId
    return this.balancesBrokerRequestStatus === RequestStatus.Error
      ? filtersPortfolioApiIdDependentButtons(accountButtons)
      : accountButtons;
  }

  public buttonAction(button: IDashButtons, onClick: Function) {
    return onClick(button.action);
  }

  @Emit('track-trade-dash-buttons-event')
  private handleDashButtonsEvents(dashStatusAction?: string | null) {
    return dashStatusAction;
  }
}
</script>

<style lang="less" scoped>
/deep/.label--secondary {
  .text-p-4();
}

/deep/ .button-box-decide {
  border-radius: @size-radius-x300;
}

/deep/ .label {
  white-space: nowrap;
}

.main-container {
  height: 100%;
}
.shortcuts-container {
  margin-top: @size-spacing-x800;
  display: flex;
  .wrn-button,
  button {
    background-color: @theme-primary !important;
  }
}

.shortcuts-container_text {
  display: flex;
  flex-direction: column;
  margin-left: @size-spacing-x500;
}

.transaction_unrealized_balance {
  margin-left: 24px;
}

.account-state-card {
  &__buttons {
    display: flex;

    &--new {
      padding-top: @spacing-xxxs;
      flex-wrap: no-wrap;
      overflow: auto;
    }

    &--old {
      flex-wrap: wrap;
    }
  }

  &__button {
    height: 132px;
    min-width: 132px;
    border-radius: @size-radius-x300;
    padding: @size-spacing-x400;

    /deep/ .label {
      .text-p-4();
    }

    &:nth-of-type(1) {
      margin-left: @size-spacing-x150;
    }
  }

  &__button {
    &--new div {
      height: 132px;
      width: 140px;
      border-radius: @size-radius-x300;
    }

    &--old div {
      height: 48px;
      width: 140px;
      border-radius: @size-radius-x200;
    }
  }
}
</style>
